import React, { useEffect, useContext } from 'react';
import { IonRouterOutlet, IonIcon, IonHeader, IonToolbar, IonTitle } from '@ionic/react';
import { wifiOutline, informationOutline } from 'ionicons/icons';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Plugins } from '@capacitor/core';

// Pages
import { LoginPage, ResetPassword } from './../pages/login';

// Constants
import { APP_CONFIG } from '../constants/config.constant';

// Helpers
import { closeAppInPagePublic, isWeb } from '../helpers';

// Contexts
import { AppContext } from '../contexts';

// Environments
import { environment } from '../environments/environment';

// Hooks
import { useVersion } from '../hooks';

export const PublicRoute = () => {

    const { network } = useContext(AppContext);
    const { App: AppScanClub } = Plugins;
    const { version } = useVersion(null);

    /**
     * Pongo a escuchar eventos de la app
     */
    useEffect(() => {

        AppScanClub.addListener('backButton', () => {

            if (closeAppInPagePublic(window.location.pathname)) {

                AppScanClub.exitApp();
            }
        });

        return () => {

            AppScanClub.removeAllListeners();
        };

    }, []);

    return (
        <>
            {
                !network.connected && !isWeb() &&
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonTitle>{APP_CONFIG.PAGES.OFFLINE.title}</IonTitle>
                        <IonIcon size="large" icon={ wifiOutline } slot="end" style={{ paddingRight: '20px' }}/>
                    </IonToolbar>
                </IonHeader>
            }
            {
                network.connected && !environment.production && version &&
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonTitle>Versión: {version}</IonTitle>
                        <IonIcon size="large" icon={ informationOutline } slot="end" style={{ paddingRight: '20px' }}/>
                    </IonToolbar>
                </IonHeader>
            }
            <IonRouterOutlet>
                <Switch>
                    <Route path={APP_CONFIG.PAGES.LOGIN.path} component={LoginPage} exact />
                    <Route path={APP_CONFIG.PAGES.RESET_PASSWORD.path} component={ResetPassword} exact />
                    <Redirect to={APP_CONFIG.PAGES.LOGIN.path} />
                </Switch>
            </IonRouterOutlet>
        </>
    )
}